<template>
  <div class="popout-modal" v-show="popoutShow">
    <div class="example-popout">
      <div class="title">行驶证示例</div>
      <div class="content"><img :src="exampleImg" alt=""></div>
      <div class="popout-btn" @click="closePopout">我知道了</div>
    </div>
  </div>
</template>
<style scoped lang="less">
@import url('../../assets/less/common.less');
.popout-modal{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.3);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .example-popout{
    width: 7.466667rem;
    height: 7.466667rem;
    border-radius: 0.08rem;
    background: #fff;
    padding-top: 0.666667rem;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    box-sizing: border-box;
    .title{
      text-align: center;
      .px2px(font-size,30px);
      color: #222;
      font-weight: bold;
    }
    .content{
      padding: 0.533333rem 0.8rem;
      img{
        display: block;
        width: 100%;
      }
    }
    .popout-btn{
      width: 100%;
      height: 1.333333rem;
      line-height: 1.133333rem;
      border-top: 1px solid #efefef;
      text-align: center;
      color: #5e5e5e;
      .px2px(font-size,30px);
      font-weight: bold;
    }
  }
}
</style>
<script>
export default {
  name: 'expamplepopout',
  data:function() {
    return {
      exampleImg: require('../../assets/img/violation/example_img_03.jpg'),
      // popoutShow: true
   
    }
  },
  props:["popoutShow"],
  mounted: function() {
  },
  methods: {
    closePopout:function(){
      this.$emit('childClosePopout',false);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/violation/examplePopout.vue